var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/lodash/_Uint8Array.js
// module id = 672
// module chunks = 0 1 2 3 4 5 6 7 8